import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import QuestionPreview from './QuestionPreview'
import { Form, Rating } from 'semantic-ui-react'
import styled from 'styled-components'

interface StarsProps {
  languageIndex: number
}

export const StyledRating = styled(Rating)`
font-size: 25px !important;
`

const Stars: React.FC<StarsProps> = (props) => {
  const { languageIndex } = props
  const { t } = useTranslation()
  const { control, getValues } = useFormContext()
  const watchQuestions = useWatch({ control, name: `languages[${languageIndex}].question` })
  const watchReq = useWatch({ control, name: 'required' })

  function renderForm() {
    return <>
      <FormFields.TextArea
        control={control}
        label={t('Type in your question')}
        placeholder={t('Type in your question')}
        name={`languages[${languageIndex}].question`}
        rules={{
          required: {
            value: true,
            message: t('Please enter question')
          }
        }}
      />
    </>
  }

  function renderPreview() {
    return <QuestionPreview>
      <Form.Field label={watchQuestions} required={Boolean(watchReq)} />
      <StyledRating
        icon='star'
        defaultRating={0}
        maxRating={getValues('value')}
        size={'large'}
      />
    </QuestionPreview>
  }

  return <>
    {renderForm()}
    {renderPreview()}
  </>
}
export default Stars